module.exports = __webpack_public_path__ + "img/3.77c3c6f0.png";